module.exports = __webpack_public_path__ + "static/media/our_platform_is_omnichannel_img.b682a69b.png";